import task from 'helpers/task'
import inject from 'helpers/inject'

import ApiService from 'services/api'

export default task(async function(login, password) {
  const api = inject(ApiService)
  const { token } = await api.request({
    url: '/api/auth/token',
    method: 'POST',
    data: { login, password }
  })
  return token
}, {
  defaultValue: ''
})



// WEBPACK FOOTER //
// ./src/tasks/createAuthToken.js